import { useState } from 'react'
import { Button, Menu, MenuItem } from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'

export default function ReportTypeMenu({ reportType, onChange }) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleSelect = (value) => {
    onChange(value)
    setAnchorEl(null)
  }

  const getDisplayText = (type) => {
    if (type === 'IQOL') return 'IQoL'
    if (type === 'IPATH_ES') return 'iPATH ES'
    if (type === 'IPATH_ENG') return 'iPATH ENG'
    if (type === 'IPATH') return 'iPATH'
    if (type === 'EXCEL') return 'Excel'
    if (type === 'THANK_YOU') return 'Thank You'
    return 'None'
  }

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        endIcon={<ArrowDropDownIcon />}
        onClick={e => setAnchorEl(e.currentTarget)}
      >
        {getDisplayText(reportType)}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        disableScrollLock
      >
        <MenuItem selected={reportType === 'NONE'} onClick={() => handleSelect('NONE')}>
          None
        </MenuItem>
        <MenuItem selected={reportType === 'IQOL'} onClick={() => handleSelect('IQOL')}>
          IQoL
        </MenuItem>
        <MenuItem selected={reportType === 'IPATH'} onClick={() => handleSelect('IPATH')}>
          iPATH
        </MenuItem>
        <MenuItem selected={reportType === 'IPATH_ES'} onClick={() => handleSelect('IPATH_ES')}>
          iPATH ES
        </MenuItem>
        <MenuItem selected={reportType === 'IPATH_ENG'} onClick={() => handleSelect('IPATH_ENG')}>
          iPATH ENG
        </MenuItem>
        <MenuItem selected={reportType === 'EXCEL'} onClick={() => handleSelect('EXCEL')}>
          Excel
        </MenuItem>
        <MenuItem selected={reportType === 'THANK_YOU'} onClick={() => handleSelect('THANK_YOU')}>
          Thank You
        </MenuItem>
      </Menu>
    </>
  )
}
